import React from 'react';
import { Paragraph } from 'common-components/typography';
import _ from 'lodash';
import { EditRecurringMode } from 'utilities/enum-utils';
import CommonUtils from 'utilities/common-utils';
import { IShiftClashConflict } from 'interfaces/service-interfaces';
import { ShiftClashContent } from 'common-components/shift-clash';

interface AssignWorkerStep17Props {
  shiftClashConflicts: IShiftClashConflict[] | undefined;
  isRecurring: boolean | undefined;
  selectedOption: EditRecurringMode | null;
  isLoading: boolean;
  onCancel: () => void;
  onSubmitShiftClash: (ignoreShiftClashShiftIds: string[]) => Promise<void>;
}

export const AssignWorkerStep17 = ({
  shiftClashConflicts,
  isRecurring,
  selectedOption,
  isLoading,
  onCancel,
  onSubmitShiftClash,
}: AssignWorkerStep17Props) => {
  const totalShiftClashes = CommonUtils.calculateTotalShiftClashes(shiftClashConflicts);
  let description = (
    <Paragraph>
      This team member is assigned to{' '}
      <b>
        {totalShiftClashes} shift{totalShiftClashes > 1 ? 's ' : ' '}
      </b>
      that conflict{totalShiftClashes === 1 ? 's' : ''} with this booking time. Be sure to double-check their
      availability before assigning.
    </Paragraph>
  );
  let firstColumnTitle = 'Booking being assigned';
  let okButtonText = 'Assign anyway';
  let hasActionButton = false;
  let hasKeepInShift = false;
  if (isRecurring && (selectedOption === null || selectedOption !== EditRecurringMode.Current)) {
    description = (
      <Paragraph>
        This team member is assigned to shifts that conflict with sessions in this recurring series. Choose whether
        you’d like to keep them in the following bookings.
      </Paragraph>
    );
    firstColumnTitle = 'Bookings';
    okButtonText = 'Confirm';
    hasActionButton = true;
    hasKeepInShift = true;
  }

  return (
    <ShiftClashContent
      shiftClashConflicts={shiftClashConflicts}
      description={description}
      firstColumnTitle={firstColumnTitle}
      okButtonText={okButtonText}
      hasKeepInShift={hasKeepInShift}
      hasActionButton={hasActionButton}
      isLoading={isLoading}
      onCancel={onCancel}
      onOk={onSubmitShiftClash}
    />
  );
};
